const defaultReceiver: Parameters<typeof JSON.parse>[1] = (_, value) => {
  if (typeof value === 'number') {
    // If the number is safe, keep it as a number
    if (value <= Number.MAX_SAFE_INTEGER) {
      return value;
    }

    // If the number exceeds safe integer limits, convert to BigInt or string
    return BigInt(value).toString();
  }

  return value;
};

export const parseJSON = <T extends object>(
  str: Parameters<typeof JSON.parse>[0] | null | undefined,
  receiver = defaultReceiver
): T | null => {
  if (!str) return null;

  // Preprocess: Convert large numbers to strings BEFORE parsing
  const preprocessedStr = str.replace(/:\s*(\d{16,})/g, ': "$1"');

  try {
    const obj = JSON.parse(preprocessedStr, receiver);

    return obj as T;
  } catch {
    // If standard JSON.parse fails, try to handle JS-like object syntax
    try {
      // Convert single quotes to double quotes and add quotes to unquoted keys
      const correctedStr = preprocessedStr
        .replace(/(['"])?([a-zA-Z0-9_]+)(['"])?:/g, '"$2":') // Add quotes to keys
        .replace(/'/g, '"'); // Replace single quotes with double quotes

      return JSON.parse(correctedStr, receiver) as T;
    } catch (error) {
      console.error('Invalid JSON or object format:', error);
      return null;
    }
  }
};
